const Footer = (props) => {
  return (
    <footer className="flex justify-center items-center h-12 md:h-14 bg-red text-center text-white font-inter text-sm md:text-lg">
      © 2024 - Kalpanax
    </footer>
  );
};

export default Footer;
